// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// import * as config from '../../config/env-config.json';
// const firebaseKey = "U2FsdGVkX19Lw6usLRf6UdNobIkFZDwoNgKwka9Xzi2aT4vxYZLMEyu9x1D9C+0vOqlkTl81kVZ1FTCdPX9HnQ==";
// const trackerFirebaseKey = "U2FsdGVkX1/Ipr9o92EYT7IhgFg74JMTmKza6kqvGMAY/56ZmM8Tzl5quTNBCw6iNnE/jBb1DTbhVkqBJ6dweQ==";

export const environment = {
  production: false,
  name: 'development',
  // apiUrl: 'https://eagle-dev.crownit.in',
  apiUrl: 'https://eagle-staging1.crownit.in',
  // apiUrl: 'https://eagle-staging.crownit.in', 
  // apiUrl: 'http://127.0.0.1:3000',
  // apiNodeUrl: 'http://node-dev.crownit.in',
  // billProcessUrl: 'https://webservices.crownit.in',
  socketUrl: 'https://bill-staging.crownit.in',
  apiNodeUrl: 'https://node-staging.crownit.in',
  // apiVocIntro: 'https://voc.crownit.in',
  apiVocIntro: 'https://voc-dev.crownit.in',
  firebase: {
    apiKey: "U2FsdGVkX19Lw6usLRf6UdNobIkFZDwoNgKwka9Xzi2aT4vxYZLMEyu9x1D9C+0vOqlkTl81kVZ1FTCdPX9HnQ==",
    authDomain: "eagle-live-2.firebaseapp.com",
    databaseURL: "https://eagle-live-2.firebaseio.com",
    projectId: "eagle-live-2"
  },
  trackerFirebase : {
    apiKey: "U2FsdGVkX1/Ipr9o92EYT7IhgFg74JMTmKza6kqvGMAY/56ZmM8Tzl5quTNBCw6iNnE/jBb1DTbhVkqBJ6dweQ==",
    authDomain: "insights-d2e35.firebaseapp.com",
    databaseURL: "https://insights-d2e35.firebaseio.com",
    projectId: "insights-d2e35"
  },
  rollbarTracker:{
    accessToken:'a989369b6e894fb5b53b2889c66508a7',
  }
  // ...config

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
